import React, { useState, useRef } from "react";
import TeamHead from "./TeamHead";
import { ASSETS_URL } from "@/Constant";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
function convertShortsToEmbed(url) {
  if (!url) return '';
  return url.replace('/shorts/', '/embed/');
}

const TeamFour = ({ isHead, showvideos, isImage }) => {
  const videosToShow = showvideos || []

  return (
    <div className="container">
      {isHead && (
        <TeamHead title="Dynamic Team Videos" desc="Fetched from API." />
      )}

      <div className="row row--15 mt_dec--30">
        {true ? (
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            loop={true} // 🔄 Infinite scroll
            pagination={{ clickable: true }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
          >
            {videosToShow.map((video, index) => (
              <SwiperSlide key={index}>
                <VideoPlayer
                  video={video}
                  videoSrc={`${ASSETS_URL}/${video.media}`}
                  isEmbead={video.type === 1}
                  shortsUrl={video.url}
                  name={video.name}
                  profession={video.profession}
                  university={video.University?.name}
                  isImage={isImage}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : showvideos ? (
          videosToShow.map((video, index) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mt--30"
              key={index}
            >
              <VideoPlayer
                video={video}
                videoSrc={`${ASSETS_URL}/${video.media}`}
                isEmbead={video.type === 1}
                shortsUrl={video.url}
                name={video.name}
                profession={video.profession}
                university={video.University?.name}
                isImage={isImage}
              />
            </div>
          ))
        ) : (
          <p>Loading videos...</p>
        )}
      </div>
    </div>
  );
};

export const VideoPlayer = ({
  video,
  videoSrc,
  name,
  shortsUrl,
  isEmbead,
  profession,
  university,
  isImage = false,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div
      className="rbt-team team-style-default style-three rbt-hover"
      style={{
        position: "relative",
        margin: "10px"
      }}
    >
      <div
        className=""
        style={{ padding: "0px !important", position: "relative" }}
      >

        {
          isEmbead ? <iframe src={convertShortsToEmbed(shortsUrl)} style={{
            width: "100%",
            height: "500px",
            borderRadius: "12px",
            objectFit: "cover",
            position: "relative",
          }} /> :
            <video
              ref={videoRef}
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "12px",
                objectFit: "cover",
                position: "relative",
              }}
            >
              <source src={videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
        }


        {!isPlaying && !isEmbead && (
          <div>
            {isImage && (
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  height: "500px",
                  width: "100%",
                  padding: "10px 20px",
                  backgroundColor: "yellow",
                  color: "red",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontSize: "6px",
                  zIndex: 1,
                  border: "none",
                  objectFit: "cover", // Only needed if you have a background image
                }}
              ></div>
            )}

            <button
              onClick={handlePlayClick}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "10px 20px",
                border: "none",
                backgroundColor: "transparent",
                color: "white",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                zIndex: 1,
              }}
            >
              <div
                className="rbt-btn rounded-player-2 popup-video position-to-top with-animation btn-white-color"
                data-vbtype="video"
              >
                <span className="play-icon"></span>
              </div>
            </button>
          </div>
        )}
      </div>
      <div className="content">
        <h2 className="title">{name}</h2>
        <h6 className="subtitle theme-gradient">{profession}</h6>
        <span className="team-form">
          {university && (
            <>
              <i className="feather-map-pin"></i>
              <span className="location">{university}</span>
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default TeamFour;
